// extracted by mini-css-extract-plugin
export default {"bgBlue":"styles_bgBlue__t5CSk","bgGreen":"styles_bgGreen__WCTTC","bgYellow":"styles_bgYellow__o8qCO"};